const useSortHandler = (setSort, setSortName) => (selectedSort) => {
  setSort(selectedSort);
  setSortName(
    {
      newest: "Newest First",
      oldest: "Oldest First",
      lastUpdated: "Last Updated",
      ascending: "Alphabetic A-Z",
      descending: "Alphabetic Z-A",
    }[selectedSort],
  );
};

export default useSortHandler;
